import api from '@/services/base.service'

const methods = {
  getTiposEntregaByBodega(bodegaId) {
    return api.get('/tiposEntrega', { params: { bodegaId } })
  }
}

export default methods
